import React, { useState, useEffect } from "react"
import { Form } from "antd"
import PropTypes from "prop-types"
import {useOutletContext} from "react-router-dom"

import { DRAWER_WIDTH } from "@components"
import { UpdateDrawer } from "@components/Page"
import { updateBatchOperation as updateOperation } from "@api/services/backstage"
import { PROJECT_FILE_CREATED, INVESTOR_FILE_CREATED } from "@api/services/notifications/shapes/TemplateKeyEnum"

import getInputs from "./helpers/getInputs"
import useCustomTemplateInputs from "./helpers/useCustomTemplateInputs"

const LABEL_ENTITY = "Batch"
const LABEL_TITLE = `Edit ${LABEL_ENTITY}`
const LABEL_SUBMIT = "Save"


const BatchUpdateDrawer = ({ drawer, table, onSuccess }) => {
  const [ form ] = Form.useForm()

  const {
    documentTypeOptions,
    projectTemplatesStore,
    batchDocumentTypeOptions,
  } = useOutletContext()

  const [ schema, setSchema ] = useState([])
  const [ batch, setBatch ] = useState({
    sentAt: undefined,
    fileUrl: undefined,
    customHtmlTemplate: undefined
  })

  const { sentAt, fileUrl, customHtmlTemplate } = batch

  const isSent = Form.useWatch("isSent", form)
  const isProjectFileBatch = !!fileUrl
  const templateKey = isProjectFileBatch
    ? PROJECT_FILE_CREATED
    : INVESTOR_FILE_CREATED

  const {
    isProjectFileCreatedTemplateEnabled,
    isInvestorFileCreatedTemplateEnabled
  } = projectTemplatesStore

  const hasScheduleOption = isProjectFileBatch
    ? isProjectFileCreatedTemplateEnabled()
    : isInvestorFileCreatedTemplateEnabled()

  const shouldRender = !!customHtmlTemplate && !sentAt && !isSent
  const customTemplateInputs = useCustomTemplateInputs(form, templateKey, shouldRender)

  useEffect(() => {
    const documentTypes = isProjectFileBatch
      ? documentTypeOptions
      : batchDocumentTypeOptions

    const typeOptions = documentTypes
      .map(name => ({ label: name, value: name }))

    const inputs = getInputs(
      sentAt,
      isSent,
      typeOptions,
      hasScheduleOption,
      isProjectFileBatch,
      customTemplateInputs
    )

    const newSchema = updateOperation.getSchema(inputs)

    setSchema(newSchema)
  }, [
    isSent,
    sentAt,
    hasScheduleOption,
    isProjectFileBatch,
    documentTypeOptions,
    batchDocumentTypeOptions,
    customTemplateInputs,
  ])

  const onOpen = targetBatch => setBatch(targetBatch)

  const updateDrawerProps = {
    title: LABEL_TITLE,
    width: DRAWER_WIDTH,
    entity: LABEL_ENTITY,
    operation: updateOperation,
    submitLabel: LABEL_SUBMIT,
    form,
    table,
    drawer,
    schema,
    onOpen,
    onSuccess,
  }

  return (
    <UpdateDrawer {...updateDrawerProps} />
  )
}

BatchUpdateDrawer.propTypes = {
  table: PropTypes.shape().isRequired,
  drawer: PropTypes.shape().isRequired,
  onSuccess: PropTypes.func.isRequired,
}

export default BatchUpdateDrawer
